import { useMeasurement } from "../../../hooks/query";
import { Box, CircularProgress, Input, Snackbar, Typography } from "@mui/joy";
import { Pencil } from "lucide-react";
import { useState } from "react";

export function GfCActualValue(props: any) {
    const value = Number(props.value) || 0;
    const returnValue = `${value} ${props.data.unit}`;

    const [flashStatus, setFlashStatus] = useState<"success" | "error" | null>(null);

    const [editorOpen, setEditorOpen] = useState(false);
    const [actualValue, setActualValue] = useState(value);

    const { useUpdateSingleMeasurement } = useMeasurement();
    const updateSvc = useUpdateSingleMeasurement();

    const performUpdate = async () => {
        try {
            setEditorOpen(false);
            const params = {
                Id: props.data.id,
                ActualValue: Number(actualValue),
            };
            await updateSvc.mutateAsync(params);
            triggerFlash("success");
            props.node.setDataValue("actual", actualValue);
        } catch (error) {
            console.error(error);
            triggerFlash("error");
        }
    };

    const handleChange = (event: any) => {
        const value = event.target.value;
        setActualValue(value);
    };

    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === "Enter") {
            performUpdate();
        }
    };

    const triggerFlash = (status: "success" | "error") => {
        setFlashStatus(status);
        setTimeout(() => {
            setFlashStatus(null);
        }, 1000); // flash duration
    };

    const toggleEditorState = (e: any) => {
        setEditorOpen((prev) => !prev);
        e.stopPropagation();
    };

    if (editorOpen) {
        return (
            <Box
                className="RoofMeasurementTable__actual-value"
                sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    gap: 1,
                    px: 2,
                    height: "100%", // ensures full cell height
                }}
            >
                <Input
                    onKeyDown={handleKeyDown}
                    className="RoofMeasurementTable__actual-input"
                    autoFocus
                    size="sm"
                    onBlur={performUpdate}
                    value={actualValue}
                    onChange={handleChange}
                    sx={{
                        borderRadius: 0,
                        height: "100%",
                        boxShadow: "none",
                        border: "none",
                        background: "transparent",
                        "--Input-focusedInset": "var(--any, )",
                        "--Input-focusedThickness": "0rem",
                        "--Input-focusedHighlight": "transparent",
                        p: 0,
                        "&:focus-within": {
                            borderColor: "transparent",
                            background: "transparent",
                        },
                        "&:hover": {
                            boxShadow: "none",
                        },
                    }}
                />
            </Box>
        );
    }
    return (
        <Box
            className={`RoofMeasurementTable__actual-value ${flashStatus === "success" ? "flash-success" : ""} ${
                flashStatus === "error" ? "flash-error" : ""
            }`}
            sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "flex-start",
                gap: 1,
                px: 2,
                height: "100%",
            }}
            onClick={toggleEditorState}
        >
            <Typography level="body-sm">{returnValue}</Typography>
            {updateSvc.isPending && (
                <CircularProgress
                    size="sm"
                    sx={{
                        "--CircularProgress-size": "16px",
                        "--CircularProgress-trackThickness": "3px",
                        "--CircularProgress-progressThickness": "3px",
                    }}
                />
            )}
            <Box className="RoofMeasurementTable__actual-value-edit-icon" display={"flex"}>
                <Pencil size={16} />
            </Box>
        </Box>
    );
}

export function GfCMeasurementType(props: any) {
    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                justifyContent: "center",
                height: "100%", // ensures full cell height
            }}
        >
            <Typography level="body-sm">{props.data.name}</Typography>
            <Typography level="body-xs" sx={{ fontWeight: 400 }}>
                {props.data.description}
            </Typography>
        </Box>
    );
}
